module.exports = __webpack_public_path__ + "static/media/Ubisend.8d5fa480.svg";